import React from 'react';
import Layout from '@components/Layout';
import styles from './styles.module.scss';
import { Grid, Divider, Col, Row } from '@components/Grid';

import { useStaticQuery, graphql } from 'gatsby';
import SEO from '@components/SEO';

const Videos = () => {
    const {
        videos: { edges },
    } = useStaticQuery(graphql`
        query Videos {
            videos: allMarkdownRemark(filter: { fileAbsolutePath: { regex: "/videos/" } }) {
                edges {
                    node {
                        frontmatter {
                            video_title
                            video_src
                            video_description
                            video_date
                        }
                    }
                }
            }
        }
    `);

    return (
        <Layout>
            <SEO
                title="Videos"
                description="We use our own stuff. Here are some demo and installation videos for our wide range of gunsmithing tools and firearms accessories."
            />
            <div className={styles.videosMain}>
                <Grid>
                    <h1>How to videos</h1>
                    <Divider />
                    <Row center="xs" start="md">
                        {edges.map(edge => {
                            const {
                                video_title,
                                video_src,
                                video_description,
                                video_date,
                            } = edge.node.frontmatter;
                            return (
                                <Col xs={12} md={6} className={styles.videocard}>
                                    <h2>{video_title}</h2>
                                    <Divider margin={2} />

                                    <iframe width="95%" height="300" src={video_src}></iframe>
                                    <Divider margin={2} />
                                    <p className={styles.date}>{video_date}</p>

                                    <Row center="xs" start="md">
                                        <Col xs={10} sm={8} md={12} lg={11}>
                                            <p className={styles.description}>
                                                {video_description}
                                            </p>
                                        </Col>
                                    </Row>
                                    <Divider xsMargin={5} mdMargin={4} />
                                </Col>
                            );
                        })}
                    </Row>
                </Grid>
            </div>
        </Layout>
    );
};

export default Videos;
